export const PARTICIPANTS_PER_SITE_PAGE = 20;

export const paginateSiteParticipants = (
  participants,
  requestedPage = 1,
  itemsPerPage = PARTICIPANTS_PER_SITE_PAGE
) => {
  const safeParticipants = Array.isArray(participants) ? participants : [];
  const safeItemsPerPage = Math.max(1, Number(itemsPerPage) || PARTICIPANTS_PER_SITE_PAGE);
  const totalItems = safeParticipants.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / safeItemsPerPage));
  const numericPage = Number(requestedPage) || 1;
  const currentPage = Math.min(Math.max(1, numericPage), totalPages);
  const startIndex = (currentPage - 1) * safeItemsPerPage;
  const endIndex = startIndex + safeItemsPerPage;
  const items = safeParticipants.slice(startIndex, endIndex);

  return {
    items,
    currentPage,
    totalPages,
    totalItems,
    startItem: totalItems === 0 ? 0 : startIndex + 1,
    endItem: Math.min(endIndex, totalItems),
    itemsPerPage: safeItemsPerPage,
  };
};
